import React from 'react'
import { SubscriptionBoxSubTitle, SubscriptionBoxTitle } from '../styles'
import { FormattedMessage } from 'react-intl'
import { useMarket } from 'src/hooks/useMarket'

export function SubscriptionSuccessMsg() {
  const { feedbackMessageType } = useMarket()

  const subtitleMessageId =
    feedbackMessageType === 'text'
      ? 'subscription.thank-you-for-being-part-of-our-community'
      : 'subscription.we-have-sent-you-an-email'

  return (
    <>
      <SubscriptionBoxTitle>
        <FormattedMessage id="global.thank-you" />
      </SubscriptionBoxTitle>
      <SubscriptionBoxSubTitle>
        <FormattedMessage id={subtitleMessageId} />
      </SubscriptionBoxSubTitle>
    </>
  )
}
